import { render, staticRenderFns } from "./VetOnboardings.vue?vue&type=template&id=5dc1c5d8&"
import script from "./VetOnboardings.vue?vue&type=script&lang=js&"
export * from "./VetOnboardings.vue?vue&type=script&lang=js&"
import style0 from "./VetOnboardings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports